/* eslint-disable max-len */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'interfaces';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/common/content-upload'] || initialState;

export const selectExpertContent = createSelector([selectDomain], (ExpertContentState) => ExpertContentState);
export const selectLoader = createSelector([selectDomain], (ExpertContentState) => ExpertContentState.loading);
export const selectExpertId = createSelector([selectDomain], (ExpertContentState) => ExpertContentState.expertId);
export const selectContent = createSelector([selectDomain], (ExpertContentState) => ExpertContentState.content);
export const selectModalState = createSelector([selectDomain], (ExpertContentState) => ExpertContentState.modal);
